import { ResultGroup } from '@src/suite/common/data-models/search-results/result-group';
import { TreeLikeFlatNode, TreeLikeNode } from '@src/suite/common/data-models/search-results/search-results';

export const SECTION_ID_PREFIX = 'section|';
export const NEW_SECTION_ID_PREFIX = 'section-new|';
export const CANDIDATE_ID_PREFIX = 'candidate|';
export const PUBLICATION_ID_PREFIX = 'publication|';
export const SECTIONS_SEQUENCE_FIELD = 'SectionsSequence';

export const getNodeLevel = ({ level }: TreeLikeFlatNode<StorytellingRecord>) => {
    return level;
};

export const getStoryNodeLevel = ({ level }: TreeLikeFlatNode<StorytellingStoryRecord>) => {
    return level;
};

// Function that determines whether a flat node is expandable or not
export const getIsNodeExpandable = ({ hasChildren }: TreeLikeFlatNode<StorytellingRecord>) => {
    return hasChildren;
};

export const getStoryIsNodeExpandable = ({ hasChildren }: TreeLikeFlatNode<StorytellingStoryRecord>) => {
    return hasChildren;
};

// Function that returns a nested node's list of children
export const getNodeChildren = ({ children }: TreeLikeNode<StorytellingRecord>) => {
    return children;
};

export const getStoryNodeChildren = ({ children }: TreeLikeNode<StorytellingStoryRecord>) => {
    return children;
};

// Function that maps a nested node to a flat node
export const nodeTransformer = (node: TreeLikeNode<StorytellingRecord>, level: number): TreeLikeFlatNode<StorytellingRecord> => {
    return {
        id: node.id,
        label: node.label,
        uniqueId: node.uniqueId,
        index: node.index,
        itemsCount: node.itemsCount,
        level,
        hasChildren: node?.children?.length > 0,
        object: node.object,
        nodeLastInGroup: node.nodeLastInGroup,
        nodeFirstInGroup: node.nodeFirstInGroup,
        linkedRecordType: node?.linkedRecordType,
        isMetadata: node?.isMetadata,
        isNewItems: node?.isNewItems,
        cost: node?.cost,
    };
};

export const getRecordsTreeLikeData = (records: ResultGroup<StorytellingRecord>): TreeLikeNode<StorytellingRecord>[] => {
    return records.keys.map((key, sectionIdx) => {
        const newSection = key.value?.startsWith(NEW_SECTION_ID_PREFIX);
        return {
            id: newSection ? key.value : `${SECTION_ID_PREFIX}${key.value}`,
            uniqueId: key.value,
            label: newSection ? key.display.replace(NEW_SECTION_ID_PREFIX, '') : key.display,
            index: sectionIdx,
            itemsCount: records.entries?.[key.value]?.length,
            children: records.entries?.[key.value]?.map((entry, index) => {
                return {
                    id: `${PUBLICATION_ID_PREFIX}${entry?.Guid}`,
                    uniqueId: `${key.value}-${entry?.Guid}`,
                    children: [],
                    object: entry,
                    index,
                    linkedRecordType: entry?.linkedRecords?.[0]?.Type,
                    nodeFirstInGroup: index === 0,
                    nodeLastInGroup: index === records.entries?.[key.value]?.length - 1,
                };
            }),
        };
    });
};

/*
export const getSearchResultsTreeLikeData = (records: ResultGroup<StorytellingRecord>): TreeLikeNode<StorytellingRecord>[] => {
    const recordsValues = Object.values(records);
    let search = [];
    recordsValues.forEach((record: ResultGroup<StorytellingRecord>) => {
        if (record && record.entries.SingleGroup && record.entries.SingleGroup.length > 0) {
            const topics = {
                id: 'topics',
                label: 'Topics',
                itemsCount: record.entries.SingleGroup.length,
                uniqueId: 'topics',
                children: record.entries.SingleGroup.map<TreeLikeNode<StorytellingRecord>>((entry, idx) => ({
                    id: entry.Guid,
                    children: [],
                    object: entry,
                    nodeFirstInGroup: idx === 0,
                    nodeLastInGroup: idx === record.entries.SingleGroup.length - 1,
                })),
            };
            search = [...search, topics];
        }
        if (record && record.keys && record.keys.length > 0 && !record.entries.SingleGroup) {
            const assignmentsAndStories = record.keys.reduce((grpAcc, key) => {
                const childrenReducer = (childrenAcc, entry, index) => {
                    const parent = childrenAcc.find(item => item.id === entry.ParentGuid);
                    if (!parent && entry.Type !== ObjectTypesEnum.SCRIPT) {
                        childrenAcc.push({
                            id: entry.ParentGuid,
                            label: entry.topicMetadata?.Title,
                            object: entry,
                            uniqueId: `assignments-${entry.ParentGuid}`,
                            isMetadata: true,
                            children: [
                                {
                                    id: entry.Guid,
                                    children: [],
                                    object: entry,
                                    uniqueId: `assignments-${entry.Guid}`,
                                    nodeFirstInGroup: index === 0,
                                    nodeLastInGroup: false,
                                },
                            ],
                        });
                    } else {
                        childrenAcc.push({
                            id: entry.Guid,
                            children: [],
                            object: entry,
                            uniqueId: `stories-${entry.Guid}`,
                            nodeFirstInGroup: index === 0,
                            nodeLastInGroup: false,
                        });
                    }
                    return childrenAcc;
                };

                if (grpAcc.id) {
                    grpAcc.children = [...grpAcc.children, ...record.entries[key.value].reduce(childrenReducer, [] as TreeLikeNode<StorytellingRecord>[])];
                } else {
                    const entries = record.entries[key.value];
                    entries.forEach(entry => {
                        if (entry.Type === ObjectTypesEnum.ASSIGNMENT) {
                            grpAcc = {
                                id: 'assignments',
                                label: 'Assignments',
                                uniqueId: 'assignments',
                                itemsCount: entries.length,
                                children: entries.reduce(childrenReducer, [] as TreeLikeNode<StorytellingRecord>[]),
                            };
                        } else {
                            grpAcc = {
                                id: 'stories',
                                label: 'Stories',
                                uniqueId: 'stories',
                                itemsCount: entries.length,
                                children: entries.reduce(childrenReducer, [] as TreeLikeNode<StorytellingRecord>[]),
                            };
                        }
                    });
                }
                return grpAcc;
            }, {} as TreeLikeNode<StorytellingRecord>);
            search = [...search, assignmentsAndStories];
        }
    });
    return search;
};
*/
